import { memo } from 'react';
import { UserNotActive } from '../../_pages/UserNotActive';
import { useConfigValuesState } from '../../hooks/useConfigValue';
import { UserNotFound } from '../../_pages/UserNotFound';

export const UserActiveCheck = memo(({ children }: { children: React.ReactNode }) => {
    const {
        initialData: { aggregatedUser },
    } = useConfigValuesState();

    const user = aggregatedUser?.user;

    if (!user) {
        return <UserNotFound />;
    }

    if (user?.isNotActive) {
        return <UserNotActive />;
    }

    return <>{children}</>;
});
